module.exports = __webpack_public_path__ + "static/media/sodexo_logo.8d4f3d87.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/integrations_logos/sodexo_logo.png
// module id = 304
// module chunks = 0